import { render, staticRenderFns } from "./planos.vue?vue&type=template&id=cc6c996c&scoped=true"
import script from "./planos.vue?vue&type=script&lang=ts"
export * from "./planos.vue?vue&type=script&lang=ts"
import style0 from "./planos.vue?vue&type=style&index=0&id=cc6c996c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6c996c",
  null
  
)

export default component.exports